<template>
  <ValidationProvider
    v-slot="{ errors }"
    ref="provider"
    :name="getName"
    :rules="getRules"
  >
    <div
      :class="{
        'form-group--error': errors.length,
        'form-group--required': isRequired
      }"
      class="form-group"
    >
      <label
        :for="name"
        class="form-label"
      >File Input</label>
      <div class="form-file u-br">
        <label :for="_uid" class="button">Choose file</label>
        <span class="form-file__label">{{ file ? file.name : 'Select a file' }}</span>
        <input
          :id="_uid"
          :name="name"
          type="file"
          class="form-input"
          @change="selected"
        >
      </div>
      <span class="form-helptext">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import FormMixin from '@components/forms/FormMixin'

export default {
  mixins: [FormMixin],
  data: () => ({
    file: null,
  }),
  methods: {
    async selected ({ target: { files }}) {
      const { valid } = await this.$refs.provider.validate(files[0])

      console.log(valid)

      if (!valid) {
        return
      }

      this.file = files[0]
      this.$emit('input', files[0])
    },
  },
}
</script>

